module.exports = __webpack_public_path__ + "img/011.711b2e36.png";